export default [
  {
    path: '/vitara',
    meta: { title: '' },
    component: () => import(/* webpackChunkName: "vitara" */ '@/pages/vitara/index.vue')
  }
]
